/**
 * @generated SignedSource<<03536970d3e6edd9d429b157e90f2336>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_item" | "PdpSharedBlurbDesignYourOwn_item" | "PdpSharedBlurbLeadTime_item" | "PdpSharedBlurbRareFind_item" | "useRenderBlurbs_item">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_item";
};
export type PdpRespSidebarBlurbs_item$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useRenderBlurbs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbLeadTime_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbDesignYourOwn_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbRareFind_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "26886bf8509005fdabc4562214b2b6e0";

export default node;
